import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ListingCard from '../components/ListingCard';
import { listings, currentUser } from '../mock';
import { Button } from '../components/ui/button';
import { Heart } from 'lucide-react';

const FavoritesPage = () => {
  const navigate = useNavigate();
  const favoriteListings = listings.filter((listing) =>
    currentUser.favorites.includes(listing.id)
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">My Favorites</h1>
          <p className="text-gray-600">
            {favoriteListings.length} {favoriteListings.length === 1 ? 'item' : 'items'} saved
          </p>
        </div>

        {favoriteListings.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {favoriteListings.map((listing) => (
              <ListingCard key={listing.id} listing={listing} />
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm p-12 text-center">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="w-10 h-10 text-gray-400" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">No favorites yet</h2>
            <p className="text-gray-600 mb-6">Start adding items to your favorites!</p>
            <Button
              onClick={() => navigate('/')}
              className="bg-red-500 hover:bg-red-600 text-white"
            >
              Browse Listings
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
